// extracted by mini-css-extract-plugin
export default {"mainContainer":"vehito_mainContainer__Q8i-w","leftSubContainer":"vehito_leftSubContainer__k+w14","rightSubContainer":"vehito_rightSubContainer__PM5mZ"};